<template>
	<nav>
		<cabecalho title="MENU.INICIO" />
		<div class="mb-5">
			<h5 class="font">
				{{ $t("GERAL.HOME_BEM_VINDO") }}
			</h5>
			<p>
				{{ $t("GERAL.HOME_DESCRICAO") }}
			</p>
			<span>
				{{ $t("GERAL.HOME_APROVEITE") }}
			</span>
		</div>

		<b-row class="mb-2">
			<b-col class="mb-3" v-if="rematriculaDisponivel">
				<b-button
					variant="teste"
					class="botao-home botao-rematricula"
					@click="irParaRematricula"
				>
					<div>
						<feather
							class="icone-mennu-home"
							type="repeat"
						></feather>
					</div>
					<span>
						{{ $t("MENU.MATRICULA_REMATRICULA") }}
					</span>
				</b-button>
			</b-col>

			<b-col class="mb-3" v-for="menu in menus" :key="menu.id">
				<b-button
					variant="teste"
					class="botao-home"
					:pill="menuAtivo.id === menu.id"
					@click="ativarMenu(menu)"
				>
					<div>
						<feather
							class="icone-mennu-home"
							:type="menu.icon"
						></feather>
					</div>
					<span>
						{{ $t(menu.i18n) }}
					</span>
				</b-button>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="auto" v-for="link in menuAtivo?.children" :key="link.id">
				<router-link class="link-home w-100" :to="`${link.to}`">
					{{ $t(link.i18n) }}
				</router-link>
			</b-col>
		</b-row>
	</nav>
</template>
<script>
// Utils & Aux:
import breadcrumb from "@/common/utils/breadcrumb";
// import listaMenus from "@/layouts/full-layout/ListaMenus.js";
import JwtService from "@/common/utils/jwt";
import ContratoService from "@/common/services/contratos/contratos.service";

// Components:
import {
	Cabecalho,
	//  Titulo
} from "@/components/headers/index";

export default {
	components: {
		Cabecalho,
		// Titulo,
	},
	data() {
		return {
			menus: [],
			menuAtivo: {},
			mostraMenuRematricula: null,
			rematriculaDisponivel: false,
		};
	},
	mounted() {
		breadcrumb.definir(this.$store, [{ titulo: this.$t("GERAL.HOME") }]);
		// this.menus = listaMenus.filter((m) => m.id !== "Home");
		this.defineMenu();
		this.verificarRematricula();
	},
	watch: {
		menus: {
			handler(value) {
				this.menuAtivo = value[0];
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		defineMenu() {
			this.menus = [...JwtService.buscarMenus()];
			this.menus = this.menus.filter((m) => m.id !== "Home");
			setTimeout(() => {
				this.mostraMenuRematricula = window.localStorage.getItem(
					"acessoMatriculaRematricula"
				);
				this.menus.forEach((item) => {
					if (item.id == "academico" && item.children.length) {
						item.children = item.children.filter(
							(child) => child.id != "PortalAlunoRematricula"
						);
					}
				});
			}, 300);
		},
		ativarMenu(menu) {
			this.menuAtivo = menu;
		},
		async verificarRematricula() {
			try {
				const params = {
					usuarioId: JwtService.buscarId(),
				};
				const data = await ContratoService.checarRematricula(params);
				this.rematriculaDisponivel = data.liberarParaRematricula;
			} catch (err) {
				console.error("Erro ao verificar rematrícula:", err);
				this.rematriculaDisponivel = false;
			}
		},
		irParaRematricula() {
			this.$router.push({ name: "matriculas" });
		},
	},
};
</script>

<style>
.icone-mennu-home {
	height: 25px;
	width: 25px;
	margin: auto;
}

.btn:not(.b-calendar .btn).botao-home {
	border-radius: 8px;
	width: 100%;
	height: 100%;
	padding: 16px 24px !important;
	gap: 10px !important;
}

.btn:not(.b-calendar .btn).botao-home:hover {
	border-color: transparent;
	background: #fff;
	filter: brightness(0.98);
	color: #344054;
}

.botao-home {
	display: grid;
	transition: filter 0.02s;
	background: #fff;
	box-shadow: 2px 6px 24px 0px rgba(16, 24, 40, 0.05);
	border-color: transparent;
	color: #344054;
	font-weight: 500;
}

.botao-home.rounded-pill {
	background: #eff8ff;
	transition: filter 0.02s;
	box-shadow: 2px 6px 24px 0px rgba(16, 24, 40, 0.05);
	color: #1570ef;
}

.botao-home.rounded-pill:hover {
	background: #eff8ff !important;
	color: #1570ef;
}

.botao-rematricula {
	background: #fff !important;
	color: #344054 !important;
	border-color: transparent !important;
	position: relative;
}

.botao-rematricula::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(135deg, #1570ef 0%, #0f5bb3 100%);
	border-radius: 8px;
	opacity: 0.1;
	z-index: -1;
}

.botao-rematricula:hover {
	background: #fff !important;
	color: #344054 !important;
	border-color: transparent !important;
	filter: brightness(0.98);
}

.botao-rematricula.rounded-pill {
	background: #eff8ff !important;
	color: #1570ef !important;
	border-color: transparent !important;
}

.botao-rematricula.rounded-pill:hover {
	background: #eff8ff !important;
	color: #1570ef !important;
}

.link-home {
	display: block;
	border-radius: 8px;
	background: #fff;
	box-shadow: 2px 6px 24px 0px rgba(16, 24, 40, 0.05);
	padding: 10px 24px !important;
	color: #344054;
	margin-bottom: 10px;
}
</style>
